<template>
    <v-card class="mt-12" flat>
        <v-card-text>
            <h2 class="primary--text text--darken-3">Form Field Lists</h2>

            <div class="d-flex d-block mx-1 my-4 py-2 align-center">
                <div class="d-flex d-inline" style="width: 60%">
                    <v-autocomplete 
                        :items="formfieldlists"
                        v-model="selected"
                        hide-details 
                        class="d-inline mr-9"
                        style="width: 20%"
                        label="Type to choose a list to manage"
                        @change="setSelectedList">
                    </v-autocomplete>
                    <v-checkbox 
                        v-if="selected"
                        v-model="sortAlphaIsChecked"
                        :disabled="sortAlphaIsChecked"
                        label="Sort Alphabetically" 
                        hide-details
                        class="mt-2 mx-3" 
                        color="primary darken-1"
                        @change="sortAlpha">
                    </v-checkbox>
                    <v-btn 
                        v-if="selected"
                        color="info" 
                        class="my-2 ml-3 d-block"
                        @click="createList">
                        New List Item
                    </v-btn>
                    
                    <!-- <v-select 
                        v-if="show_secondary_select"
                        v-model="search_params.criteria_value"
                        :items="list_options"
                        hide-details 
                        class="d-inline"
                        :label="`Select ${indefinite_article} ${selected_list_name}`"
                        @change="selectedCriteria">
                    </v-select> -->
                </div>

                <div class="d-flex d-inline">
                    <!-- <v-btn
                        v-if="show_submit"
                        outlined
                        color="primary darken-1"
                        class="mt-3 ml-3 d-inline"
                        @click="searchBuyers()">
                        Search
                    </v-btn>
                    <v-btn
                        v-if="buyers.length"
                        color="primary darken-1"
                        hide-details
                        class="mt-3 ml-4 d-inline"
                        @click="searchBuyers(true)">
                        Export
                    </v-btn>

                    <h2 v-if="buyer_count !== false"
                        class="d-inline d-flex ml-6 pb-2 accent--text text--darken-3 font-weight-medium align-end">
                        {{ buyer_count }} {{ buyer_count == 1 ? 'buyer' : 'buyers' }} found
                    </h2> -->
                </div>
            </div>
            
                <v-data-table
                  v-if="selected"
                  :items="this.selectedLists"
                  :headers="list_headers"
                  disable-sort
                  sort-by="sort_order"
                  @click:row="editForm">

                  <template v-slot:[`item.is_active`]="{ item }">
                      <td @click.stop class="pa-0 ma-0">
                          <div class="d-flex justify-end">
                              <v-switch 
                                  :input-value="item.is_active"
                                  disabled
                                  color="success darken-2" 
                                  hide-details 
                                  inset
                                  class="mt-n1"
                                  @change="listingActive(item, $event)">
                              </v-switch>
                          </div>
                      </td>
                  </template>

                  <!-- <template v-slot:[`item.is_alpha`]="{ item }">
                      <td @click.stop class="pa-0 ma-0">
                          <div class="d-flex justify-end">
                              <v-switch 
                                  :input-value="item.is_alpha"
                                  color="success darken-2" 
                                  hide-details 
                                  inset
                                  class="mt-n1"
                                  @change="listingActive(item, $event)">
                              </v-switch>
                          </div>
                      </td>
                  </template> -->

                  <template v-slot:[`item.sort_order`]="{ item }">
                      <div class="text-start">{{ item.sort_order }}</div>
                  </template>



                </v-data-table>
            <!-- <v-data-table
                :headers="buyers_header"
                :items="buyers"
                item-key="buyer_id"
                class="elevation-0 buyers_table"
                style="border-top: 1px solid #D9D9D9"
                fixed-header
                :height="buyers.length ? '60vh' : '10vh'"
                loader-height="6"
                sort-by="last_name"
                :items-per-page="-1"
                :loading="show_loader"
                loading-text="Loading... Please wait">

                <template v-slot:[`item.listings`]="{ item }">
                    <template v-for="(listing, ndx) in item.listings">
                        <div :key="ndx" class="d-block listings"  
                            :style="listing.includes('Reject') || listing.includes('Bad Buyer') ? 'color:#9E9E9E' : 'color:#3693a1'"
                            v-html="listing">
                        </div>
                    </template>
                </template>

                <template v-slot:[`item.aum`]="{ item }">
                    <div class="text-start">{{ item.formatted_aum }}</div>
                </template>
                
            </v-data-table> -->
        </v-card-text>
    </v-card>
</template>

<script>
    import axios from 'axios';
    import Cookie from 'js-cookie';
    import appUrls from '../../helpers/environment';

    export default {
        name: 'FormFieldLists',

        props: {
            triggerUserFeedback: Function
        },
        
        data: () => ({
            selected: null,
            selectedLists: [],
            formfieldlists: [],
            allListData: [],
            sortAlphaIsChecked: false,
            list_headers: [
              // { text: 'Name',     value: 'text',    align: 'start',   sortable: true },
                { text: 'Name',     value: 'text',    align: 'start'},
                { text: 'Active',     value: 'is_active',    align: 'left'},
                { text: 'Order',     value: 'sort_order',    align: 'left'},
                // { text: 'Hubspot',     value: 'hubspot_internal',    align: 'left'},
            ]
        }),

        watch: {},

        created () {
            this.getLists()
          },
          beforeUpdate () {
          if (this.$route.params.listName && this.allListData.length > 0) {
            this.selected = this.$route.params.listName;
            this.allListData.forEach((list) => {
                if(list.list_name === this.$route.params.listName) {
                    this.selectedLists.push(list)
                }
            })
            this.sortAlphaIsChecked = this.selectedLists[0].is_alpha
          }
        },

        methods: {
            getLists: async function () {
                try {
                    const all_lists_rs = await axios.post(`${appUrls.api}/api/admin/formfieldlists`, {
                        headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" }
                    })
                
                    // console.log(all_lists_rs.data)
                    if(all_lists_rs.data.outcome){
                        let arrLists = all_lists_rs.data.lists;   
                        for (let l in arrLists) {
                            // const hr_listname = arrLists[l].list_name.replace(/-/g, ' ').replace(/_/g, ' ')
                            this.formfieldlists.push({ text: arrLists[l].list_name, value: arrLists[l].list_name, list: arrLists[l].list })
                            this.allListData[l] = arrLists[l]
                        }
                    }
                } catch ( error ) {
                    console.log(error);
                };
            },
            setSelectedList() {
                this.selectedLists = [];
                this.allListData.forEach((list) => {
                    if(list.list_name === this.selected) {
                        this.selectedLists.push(list)
                    }
                })
                this.sortAlphaIsChecked = this.selectedLists[0].is_alpha
            },
            editForm(item) {
                this.$router.push({ path: `/form_field_details/${item.id}`});
            },
            sortAlpha: async function() {
                axios.post(`${appUrls.api}/api/admin/sortformfieldlistsalpha`,  {
                    headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" },
                    data: {list_name: this.selected, is_alpha: this.sortAlphaIsChecked},
                })
            },
            createList() {
                // console.log("this.selected", this.selected)
                this.$router.push({ path: `/new_form_field/${this.selected}`});
            }
        }
    }
</script>

<style scoped>
    .buyers_table >>> td {
        padding-top: .25em;
        padding-bottom: .1em;
        padding-left: 0; /* .15em */
        padding-right: 0;
        vertical-align: top;
        font-size: .9em;
    }
    .buyers_table >>> th {
        padding-left: 0 !important; /* .15em */
        padding-right: 0 !important;
        font-size: .9em !important;
        background-color: #eef7f8 !important;
    }
    div.listings:nth-of-type(even) {
        /* background-color: #eef7f8; */
        padding: 2px 0;
    }
</style>


// WEBPACK FOOTER //
// src/components/datamanagement/FormFieldLists.vue